import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { APP_INITIALIZER, enableProdMode, isDevMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withPreloading,
} from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { appInitializer } from "@app/app.initializer";
import {
  AttachmentsEfffects,
  AuthEffects,
  ChecklistEffects,
  ChecklistLineEffects,
  ChecklistTemplateEffects,
  CompanyEffects,
  DiveJobsEffects,
  DiveLogEffects,
  DiveLogLineEffects,
  DiveLogTemplateEffects,
  DiveSitesEffects,
  OfflineQueueEffects,
  OperationEffects,
  PartnerEffects,
  RiskAssessmentEffects,
  ToolboxTalkEffects,
  ToolboxTalkTemplateEffects,
  UserEffects,
} from "@app/state/effects";
import { metaReducers, rootReducers } from "@app/state/reducers";
import { Capacitor } from "@capacitor/core";
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from "@ionic/angular/standalone";
import { provideEffects } from "@ngrx/effects";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { AppComponent } from "./app/app.component";
import { routes } from "./app/app.routes";
import { AuthInterceptor } from "./app/services/auth.interceptor";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideStore(rootReducers, { metaReducers }),
    provideEffects([
      AuthEffects,
      CompanyEffects,
      UserEffects,
      PartnerEffects,
      DiveJobsEffects,
      DiveSitesEffects,
      OperationEffects,
      ChecklistEffects,
      ChecklistLineEffects,
      ChecklistTemplateEffects,
      ToolboxTalkEffects,
      ToolboxTalkTemplateEffects,
      DiveLogEffects,
      DiveLogLineEffects,
      DiveLogTemplateEffects,
      AttachmentsEfffects,
      RiskAssessmentEffects,
      OfflineQueueEffects,
    ]),
    provideStoreDevtools({ maxAge: 25, logOnly: false }),
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode() && !Capacitor.isNativePlatform(),
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
});
